import React from 'react'

import Slider from 'react-slick';

import { SearchProvider } from '../Search/Hook/searchStates'

import Search from '../Search'
import MostWantedCard from './MostWantedCard'

import * as S from './styled'

const Showcase = ({ mostWanted, negotiationCode }) => {

  const settings = {
    dots: false,
    autoplay: false,
    infinite: false,
    autoplaySpeed: 10000,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false
  }

  return (
    <S.ContainerShowcase
      id='ContainerShowcase-div'
      data-testid='ContainerShowcase-div'
      data-item-text='Módulo Exames'
      data-item-position='Módulo Exames'
      data-current-service='Home'
    >
      <S.ShowcaseTitle id='ShowcaseTitle-h2' data-testid='ShowcaseTitle-h2'>
        Qual exame você procura?
      </S.ShowcaseTitle>
      <SearchProvider>
        <Search />
      </SearchProvider>
      <S.MostWantedTitle id='MostWantedTitle-h2' data-testid='MostWantedTitle-h2'>
        Exames mais pesquisados
      </S.MostWantedTitle>
      <S.ContainerMostWanted id='ContainerMostWanted-div' data-testid='ContainerMostWanted-div'>
        <Slider {...settings} id='Slider-slider' data-testid='Slider-slider'>
          {mostWanted.map((item, index) => {
            return (
              <MostWantedCard key={index} mostWanted={item} negotiationCode={ negotiationCode } />
            )
          })}
        </Slider>
      </S.ContainerMostWanted>
      <S.ContainerMoreItens
        id='ContainerMoreItens-a'
        data-testid='ContainerMoreItens-a'
        data-item-text='Ver mais exames'
        data-item-position='Módulo Exames'
        data-current-service='Home'
        href='/exames'
      >
        <S.MoreItemsTitle id='MoreItemsTitle-p' data-testid='MoreItemsTitle-p'>
          Ver mais exames
        </S.MoreItemsTitle>
        <S.ArrowIcon id='ArrowIcon-svg' data-testid='ArrowIcon-svg' />
      </S.ContainerMoreItens>
    </S.ContainerShowcase>
  )
}

export default Showcase
